var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZurueckstellen = function SvgZurueckstellen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 0h8v2h-8Zm0 5.5h8v2h-8Zm0 5.5h8v2h-8ZM0 6.5A6.487 6.487 0 0 0 6.5 13H7v2l3-3-3-3v2h-.5a4.5 4.5 0 0 1 0-9H10V0H6.5A6.487 6.487 0 0 0 0 6.5Z"
  })));
};
export default SvgZurueckstellen;